import React from "react";
import { FileJson } from "lucide-react";

const h2 = { margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", color: "#191c1d", fontFamily: "'Reckless Neue Variable', serif" };

export default function McpResponses({ catalog }) {
  const c = catalog?.conventions || {};
  const rows = [
    ["Results & pagination", `Max ${c.max_results_per_call ?? 20} results per call. ${c.pagination || ""}`],
    ["Third-party content", c.external_content],
    ["What is (and isn't) returned", c.content_policy],
    ["Attribution", c.attribution],
    ["Errors", c.errors ? `401 — ${c.errors["401"]} · 403 — ${c.errors["403"]} · 429 — ${c.errors["429"]}. ${c.errors.shape}` : null],
  ].filter(([, v]) => v);
  return (
    <section id="responses" style={{ background: "#fff", padding: "48px 24px", borderTop: "1px solid #e8ecee", borderBottom: "1px solid #e8ecee" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          <FileJson style={{ width: 18, height: 18, color: "#006874" }} />
          <h2 style={h2}>How responses work</h2>
        </div>
        <dl data-testid="mcp-responses" style={{ margin: 0, display: "grid", gridTemplateColumns: "minmax(140px, 200px) 1fr", gap: "12px 18px", fontSize: 13, lineHeight: 1.65 }}>
          {rows.map(([k, v]) => (
            <React.Fragment key={k}>
              <dt style={{ fontWeight: 700, color: "#191c1d" }}>{k}</dt>
              <dd style={{ margin: 0, color: "#3b494c" }}>{v}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </section>
  );
}
